module.exports = __webpack_public_path__ + "static/media/verified_user.83691f3c.svg";